export const failXTime = 1500
export const numberOfAnswers = 10
export const numberOfGuesses = 4
export const numberOfRounds = 3
export const enterCheck = (event = null) =>
	event !== null && event.type === "keydown" && event.key !== "Enter"
